import React from 'react'

export default function Photos() {
  return (
     <div className="photo-grid">
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
        <img src="/images/still-life-makeup-products.png" alt="Photo 1" />
    </div>
  )
}
